import { Vue, Component, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { ElForm } from 'element-ui/types/form';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import style from './style.vue';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import baseAPIService from '@/services/base/baseAPIService';
import chooseGoosClass from '@/views/components/chooseGoodsClass';
import { Functions } from '@/library/utils/functions';
import { noop } from '@/util';
import { IPSService } from '@/services/ipsServices';

@DialogFactory
@Component({
  mixins: [style],
  components: {},
})
export default class BatchAdd extends IPSDialog {
  fileName = '';
  /**
   * 文件上传地址
   * @type {string}
   */
  fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  corpId = baseAPIService.resolveCorpId();

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  width = '700px';

  // 导入的文件
  importFile = null;

  // 限制问价大小
  maxSize = 0;
  // 上下架radio选择
  addRadio = 1;

  state = null;
  // 是否由正常页面打开的对话框
  isNormal = true;

  // title = "";
  // 导入地址
  importUrl = '';

  // 导入参数
  importParams = '';

  // 员工编号
  empCode = '';

  importSendToId = `${appEnvConfig.NODE_ENV}import${Date.now()}`;

  // socket准备状态
  isSocketReady = false;

  // 失败数量
  failNum = 0;

  /**
   * 导入状态 1 导入中 2 导入成功 3 导入失败
   * @type {number}
   */
  importState = 0;

  // 失败数据文件下载地址
  failFileURL = '';

  // 导入后默认上架 false 0 不上 true 1 上 默认勾选
  openDefault = true;

  // 不显示默认上下架
  notShelf = false;

  // 路由参数
  urlPrams: ItemObject = {};

  // 确定按钮禁用
  readonly = true;

  // 商品分类分配
  classIds = [];

  // 网点Id
  siteId = 0;

  // 网点分类列表
  siteClassList = [];

  // 成功商品数量
  successGoodsCount = 0;

  // 商品总数
  goodsCount = '0';

  async mounted() {
    this.closeSockets();
    this.createConnect();
    if (this.notShelf) {
      this.openDefault = false;
    }
  }

  beforeClose() {
    this.importState === 1
      ? this.$confirm('当前商品数据正在导入中，关闭弹窗将中断导入确认关闭？', { type: 'warning' }).then((result) => {
        if (result === 'confirm') {
          this.closeSockets();
          this.$emit('hidden');
        }
      }, noop)
      : (() => {
        this.closeSockets();
        this.$emit('hidden');
      })();
  }

  onCancel() {
    this.importState === 1
      ? this.$confirm('当前商品数据正在导入中，关闭弹窗将中断导入确认关闭？', { type: 'warning' }).then((result) => {
        if (result === 'confirm') {
          this.closeSockets();
          this.$emit('hidden');
        }
      }, noop)
      : (() => {
        this.closeSockets();
        this.$emit('hidden');
      })();
  }

  getClass() {
    return IPSService.siteClassList({
      postParams: {
        siteId: this.siteId,
      },
    }).then((response) => {
      return response.list || [];
    });
  }

  onBeforeUpload(file) {
    const fileType = file.name.slice(Math.max(0, file.name.lastIndexOf('.') + 1));
    const extension2 = fileType === 'xlsx';
    this.fileName = file.name;
    this.importFile = file;
    let result = true;
    if (!extension2) {
      this.$message({
        message: '上传文件只能是 xls、xlsx、excel格式!',
        type: 'warning',
      });
      result = false;
    }
    if (this.maxSize) {
      const LtSize = file.size / 1024 <= this.maxSize;
      if (!LtSize) {
        this.$message.error(`上传文件大小不能超过${this.maxSize / 1024}M!`);
        result = false;
      }
    }
    return result;
  }

  uploaduccess() {
    this.$message.success('文件上传成功');
  }

  uploadError() {
    this.$message.error('文件上传失败');
  }

  onImport() {
    this.goodsCount = '0';
    this.successGoodsCount = 0;
    this.importState = 1;
    this.failFileURL = '';
    const fileFormData = new FormData();
    fileFormData.append('sendToId', this.importSendToId);
    fileFormData.append('file', this.importFile, this.fileName);
    if (this.state) {
      fileFormData.append('state', this.state);
    }
    Object.keys(this.importParams).forEach((v) => {
      fileFormData.append(v, this.importParams[v]);
    });
    axios({
      url: `${Functions.ipsHostUrlApi() + this.importUrl}?corpId=${this.corpId}`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': this.tokenData.Authorization,
      },
      data: fileFormData,
    })
      .then()
      .catch((err) => {
        console.log(err);
      });
  }

  async uploadFileImport() {
    Functions.limitClick(1000).then(async(res) => {
      const fileFormData = new FormData();
      fileFormData.append('file', this.importFile, this.fileName);
      Object.keys(this.importParams).forEach((v) => {
        fileFormData.append(v, this.importParams[v]);
      });
      axios({
        url: `${Functions.ipsHostUrlApi() + this.importUrl}?corpId=${this.corpId}&siteId=${this.siteId}`,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': this.tokenData.Authorization,
        },
        data: fileFormData,
      })
        .then((res) => {
          if (res.data.content.result) {
            this.$message.success('导入成功');
            this.readonly = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  // 创建socket
  createConnect() {
    setTimeout(() => {
      this.$socket.connect();
      this.onSokectConnect();
    }, 0);
    setTimeout(() => {
      this.isSocketReady = true;
    }, 1500);
  }

  /**
   * 第一位 success finish  success 成功 finish 失败
   * 第二位 导入成功数量
   * 倒数第二位 0 导入成功
   * 倒数第一位 失败数量
   */
  onSokectConnect() {
    this.$socket.emit('login', this.importSendToId);
    this.sockets.subscribe('new_msg', (msg) => {
      if (msg) {
        let msgArr = [];
        let msgInfo: any = {};
        if (!this.state) {
          if (msg.includes('|')) {
            msgArr = msg.split('|');
          }
          if (msg.includes('&quot;')) {
            msgInfo = JSON.parse(msg.replaceAll('&quot;', '"'));
          }
          console.log('msgArr=====================', msgArr);
          //  导入和导出成功
          if (msgArr[0] === 'success' || msgInfo?.code === 1) {
            this.failFileURL = msgInfo?.url;
            // 导出成功
            if (msgArr[msgArr.length - 2] === '1' || msgInfo?.url) {
            }
            // 导入成功
            if (msgArr[msgArr.length - 2] === '0') {
              this.importState = 2;
              this.successGoodsCount = Number(msgArr[1]);
              this.readonly = !this.successGoodsCount;
              this.goodsCount = msgArr[2];
            }
            // 生成文件失败(导出)
          } else if (msgArr[0] === 'fail' || msgInfo?.code === 0) {
            this.failFileURL = msgInfo?.url;
          } else if (msgArr[0] === 'finish') {
            this.importState = 3;
            // 第二位 不存在视为超出导入数量限制
            if (!msgArr[1]) {
              this.$message.warning('每次最多支持导入500件商品');
              this.goodsCount = msgArr[msgArr.length - 1] || 0;
              this.importState = 0;
              this.importFile = null;
              this.fileName = '';
              this.closeSockets();
              this.importSendToId = `${appEnvConfig.NODE_ENV}import${Date.now()}`;
              this.isSocketReady = false;
              this.createConnect();
              // 否则为正常失败(有查不到商品的货号)
            } else {
              this.failFileURL = msgArr[msgArr.length - 1] || 0;
            }
          } else if (msgArr[0] === 'finish') {
            // 导入中
            this.importState = 3;
            // 第二位 不存在视为超出导入数量限制
            if (!msgArr[1]) {
              this.$message.warning('每次最多支持导入500件商品');
              this.goodsCount = msgArr[msgArr.length - 1] || 0;
              this.importState = 0;
              this.importFile = null;
              this.fileName = '';
              this.closeSockets();
              this.importSendToId = `${appEnvConfig.NODE_ENV}import${Date.now()}`;
              this.isSocketReady = false;
              this.createConnect();
              // 否则为正常失败(有查不到商品的货号)
            } else {
              this.failFileURL = msgArr[msgArr.length - 1] || 0;
            }
          } else if (msgArr[0] === 'loading') {
            this.importState = this.importState === 2 || this.importState === 3 ? this.importState : 1;
            if (this.importState === 1) {
              this.successGoodsCount += Number(msgArr[1]);
              this.goodsCount = msgArr[2];
              // 导入失败
            } else {
              this.importState = 3;
              // 第二位 不存在视为超出导入数量限制
              if (!msgArr[1]) {
                this.$message.warning('每次最多支持导入500件商品');
                this.goodsCount = msgArr[msgArr.length - 1] || 0;
                this.importState = 0;
                this.importFile = null;
                this.fileName = '';
                this.closeSockets();
                this.importSendToId = `${appEnvConfig.NODE_ENV}import${Date.now()}`;
                this.isSocketReady = false;
                this.createConnect();
                // 否则为正常失败(有查不到商品的货号)
              }
              if (msgInfo) {
                this.failFileURL = msgInfo?.url;
              } else {
                this.failFileURL = msgArr[msgArr.length - 1] || 0;
              }
            }
          }
        } else {
          msgInfo = JSON.parse(msg.replaceAll('&quot;', '"'));
          console.log('msgInfo=====================', msgInfo);
          this.failFileURL = msgInfo?.url;
          this.goodsCount = msgInfo?.successNum + msgInfo?.failNum;
          this.successGoodsCount = msgInfo?.successNum;
          if (msgInfo?.code === 1) {
            this.importState = 2;
            this.readonly = !this.successGoodsCount;
          } else {
            this.$message.error('导入文件失败');
            this.importState = 0;
            this.importFile = null;
            this.fileName = '';
            this.closeSockets();
            this.importSendToId = `${appEnvConfig.NODE_ENV}import${Date.now()}`;
            this.isSocketReady = false;
          }
        }
      }
    });
  }

  // 关闭socket
  public closeSockets() {
    this.sockets && this.sockets.unsubscribe && this.sockets.unsubscribe('new_msg'); // 取消订阅
    this.$socket && this.$socket.disconnect(); // 断开连接
  }

  async chooseClass() {
    this.siteClassList = await this.getClass();
    const selected = this.classIds;
    chooseGoosClass.open({ siteId: this.siteId, selectType: 2, dataSource: this.siteClassList, selected }).then((result) => {
      this.classIds = result;
      this.readonly = !(this.importState === 2 || this.importState === 3) || !this.successGoodsCount;
    }, noop);
  }

  downloadTemplate(type) {
    Functions.excelMaker({
      columns: [{ header: '商品货号', key: 'code', width: 15 }],
      data: !this.state ? (type ? [{ code: 'A001' }, { code: 'A002' }, { code: 'B001' }, { code: 'B002' }] : []) : [],
      name: !this.state ? (type ? '范例' : '模板') : '商品列表',
    });
  }

  downloadFail() {
    window.location.href = this.failFileURL;
  }

  onConfirm() {
    this.readonly = true;
    if (!this.isNormal) {
      this.$emit('result');
      this.$emit('hidden');
      return;
    }
    if (this.state) {
      IPSService.siteProductChangeState({
        postParams: {
          siteId: this.siteId,
          state: this.addRadio,
          sendToId: this.importSendToId,
        },
      }).then(
        (response) => {
          if (response.result) {
            this.$message.success('更新成功');
            this.closeSockets();
            this.$emit('result');
            this.$emit('hidden');
          }
        },
        () => {
          this.readonly = false;
        },
      );
    } else {
      IPSService.siteAddProductImportConfirm({
        postParams: {
          siteId: this.siteId,
          classIds: this.classIds,
          openDefault: this.openDefault,
          sendToId: this.importSendToId,
        },
      }).then(
        (response) => {
          this.$message.success('添加成功');
          this.closeSockets();
          this.$emit('result');
          this.$emit('hidden');
        },
        () => {
          this.readonly = false;
        },
      );
    }
  }

  classConfig() {
    let u = '/#/siteManage/site';
    this.urlPrams.page = 2;
    Object.keys(this.urlPrams).forEach((k) => {
      return (u += `/${this.urlPrams[k]}`);
    });
    const target = this.$refs.target;
    // @ts-expect-error
    target.setAttribute('href', u);
    // @ts-expect-error
    target.click();
    return false;
    // window.open(u,"newWindow");
  }

  renderClassName(classId) {
    const parentClass = this.siteClassList.find(v => (v.children || []).find(vf => vf.classId === classId)) || {};
    const parentClassName = parentClass ? parentClass.className : '';
    const childrenClass = (parentClass.children || []).find(v => v.classId === classId);
    const childrenName = childrenClass ? childrenClass.className : '';
    return `${parentClassName} - ${childrenName}`;
  }

  /**
   * 移除分类
   * @param i
   */
  removeClass(i: number) {
    this.classIds.splice(i, 1);
  }

  /**
   *
   */
  stopImport() {
    this.$confirm('当前商品数据正在导入中，关闭弹窗将中断导入确认关闭？', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.importState = 0;
        this.importFile = null;
        this.fileName = '';
        this.closeSockets();
        this.importSendToId = `${appEnvConfig.NODE_ENV}import${Date.now()}`;
        this.isSocketReady = false;
        this.createConnect();
      }
    });
  }

  renderContent(h) {
    return (
      <div>
        {this.isNormal ? (
          this.state ? (
            <div class="batch-add-container">
              <el-button type="primary" onClick={this.downloadTemplate.bind(this)}>
                下载模板
              </el-button>
              <span class="tips r-ml-14">
                <span class="redText">*&nbsp;</span>
                仅支持已入库商品的批量上下架操作。
              </span>
              <div class="batch-import">
                <el-input placeholder="请选择文件" value={this.fileName} disabled={true} style="width: 80%">
                  <template slot="append">
                    <el-upload
                      action={this.fileTpConfig}
                      multiple={false}
                      headers={this.tokenData}
                      before-upload={this.onBeforeUpload}
                      on-success={this.uploaduccess}
                      on-error={this.uploadError}
                      show-file-list={false}
                      data={{ coprId: this.corpId }}
                      accept=".xlsx">
                      <el-button size="small" type="primary" slot="trigger">
                        选择
                      </el-button>
                    </el-upload>
                  </template>
                </el-input>
                <el-button type="primary" class="r-ml-20" onClick={this.onImport.bind(this)} loading={this.importState === 1} disabled={!this.fileName || !this.isSocketReady}>
                  导入
                </el-button>
              </div>
              <div class="import-result">
                {this.importState === 1 && [
                  <span>
                    正在导入中,请不要关闭弹窗,当前进度&nbsp;<span class="text-green">{this.successGoodsCount}</span>/{this.goodsCount}&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>,
                  <span class="scopeSpan" onClick={this.stopImport.bind(this)}>
                    停止导入
                  </span>,
                ]}
                {(this.importState === 2 || this.importState === 3) && (
                  <div>
                    <span>
                      共导入<span class="redText">{this.goodsCount}</span>个货号,其中有效货号
                      <span class="redText">{this.successGoodsCount}</span>个。
                    </span>
                    <p class="good-import-result" onClick={this.downloadFail.bind(this)}>
                      查看商品导入结果
                    </p>
                    <div class="p-class1">
                      <p>将所导入的有效商品设置为</p>
                      <el-radio-group v-model={this.addRadio}>
                        <p>
                          <el-radio label={1}>上架</el-radio>
                        </p>
                        <p>
                          <el-radio label={0}>下架</el-radio>
                        </p>
                        <p>
                          <el-radio label={2}>
                            恢复系统接管上下架
                            <el-tooltip effect="light" placement="top" content="手工上下架的商品，将不会被系统自动上下架策略影响。对导入的商品执行【恢复系统接管上下架】，将把上下架权限恢复系统接管。">
                              <i class="el-icon-info r-ml-4 text-grey"></i>
                            </el-tooltip>
                          </el-radio>
                        </p>
                      </el-radio-group>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div class="batch-add-container">
              <el-button type="primary" onClick={this.downloadTemplate.bind(this, 0)}>
                下载模板
              </el-button>
              <span class="scopeSpan r-ml-10" onClick={this.downloadTemplate.bind(this, 1)}>
                查看范例
              </span>
              <div class="batch-import">
                <el-input placeholder="请选择文件" value={this.fileName} disabled={true} style="width: 80%">
                  <template slot="append">
                    <el-upload
                      action={this.fileTpConfig}
                      multiple={false}
                      headers={this.tokenData}
                      before-upload={this.onBeforeUpload}
                      on-success={this.uploaduccess}
                      on-error={this.uploadError}
                      show-file-list={false}
                      data={{ coprId: this.corpId }}
                      accept=".xlsx">
                      <el-button size="small" type="primary" slot="trigger">
                        选择
                      </el-button>
                    </el-upload>
                  </template>
                </el-input>
                <el-button type="primary r-ml-20" onClick={this.onImport.bind(this)} loading={this.importState === 1} disabled={!this.fileName || !this.isSocketReady}>
                  导入
                </el-button>
              </div>
              <div class="import-result">
                {this.importState === 0 && (
                  <span class="tip">
                    <span class="redText">*&nbsp;</span>商品一次性最多支持导入500个
                  </span>
                )}
                {this.importState === 1 && [
                  <span>
                    正在导入中,请不要关闭弹窗,当前进度<span class="text-green r-ml-12">{this.successGoodsCount}</span>/{this.goodsCount}&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>,
                  <span class="scopeSpan" onClick={this.stopImport.bind(this)}>
                    停止导入
                  </span>,
                ]}
                {(this.importState === 2 || this.importState === 3) && (
                  <span>
                    共导入<span class="redText">{this.goodsCount}</span>个货号,其中有效货号
                    <span class="redText">{this.successGoodsCount}</span>个,点击确定按钮正式添加。
                  </span>
                )}
                {!!this.failFileURL && Number(this.goodsCount) <= 500 && (
                  <span class="scopeSpan" onClick={this.downloadFail.bind(this)}>
                    查看商品导入结果
                  </span>
                )}
              </div>
              {this.notShelf ? (
                ''
              ) : (
                <div class="p-class">
                  <el-checkbox v-model={this.openDefault} class="r-mt-12 inline-block">
                    导入后默认上架
                  </el-checkbox>
                </div>
              )}
            </div>
          )
        ) : (
          <div class="r-pa-20">
            <el-input placeholder="请选择文件" value={this.fileName} disabled={true} style="width: 80%">
              <template slot="append">
                <el-upload
                  action={this.fileTpConfig}
                  multiple={false}
                  headers={this.tokenData}
                  before-upload={this.onBeforeUpload}
                  on-success={this.uploaduccess}
                  on-error={this.uploadError}
                  show-file-list={false}
                  data={{ coprId: this.corpId }}
                  accept=".xlsx">
                  <el-button size="small" type="primary" slot="trigger">
                    选择
                  </el-button>
                </el-upload>
              </template>
            </el-input>
            <el-button type="primary r-ml-20" onClick={this.uploadFileImport.bind(this)} disabled={!this.fileName}>
              导入
            </el-button>
          </div>
        )}
      </div>
    );
  }
}
